import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import FacebookIcon from "common/icons/FacebookIcon"
import LinkdinIcon from "common/icons/LinkdinIcon"
import Image from "next/image"
import { offScreen } from "theme/shared"

const Styled = {
  LinksWrapper: styled.div`
    ${offScreen({ xPos: "calc(-100% - 80vh)" })}
    display: flex;
    flex-direction: column;
    align-items: center;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin-top: 20px;
    }
  `,
  Email: styled.a`
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.darkRoyalBlue};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 22px;
    }
  `,
  IconsList: styled.div`
    display: flex;
    justify-content: center;
    > * {
      margin: 0 -5px;

      ${(p) => p.theme.breakpoints.up("md")} {
        svg {
          width: 35px;
          height: 35px;
        }
      }
    }
  `,
}

interface SocialLink {
  id: number
  platform: string
  url: string
  icon: string
  order: number
}

interface LinksWrapProps {
  email?: string
  socialLinks?: SocialLink[]
}

const LinksWrap = ({ email, socialLinks }: LinksWrapProps) => {
  // Default values
  const defaultEmail = "info_mint@mintapp.co.il"
  const defaultSocialLinks: SocialLink[] = [
    {
      id: 1,
      platform: "Facebook",
      url: "https://www.facebook.com/Mint-446936532109191/",
      icon: "facebook",
      order: 0,
    },
    {
      id: 2,
      platform: "LinkedIn",
      url: "https://www.linkedin.com/company/mint-marketing-innovation-technology/",
      icon: "linkedin",
      order: 1,
    },
  ]

  const displayEmail = email || defaultEmail
  const displaySocialLinks = socialLinks || defaultSocialLinks

  // Helper to render social icon
  const renderSocialIcon = (link: SocialLink) => {
    // Use default icons for known platforms
    if (
      link.platform.toLowerCase() === "facebook" ||
      link.icon === "facebook"
    ) {
      return <FacebookIcon />
    }
    if (
      link.platform.toLowerCase() === "linkedin" ||
      link.icon === "linkedin"
    ) {
      return <LinkdinIcon />
    }
    // For custom icons, use Image component
    if (link.icon && link.icon.startsWith("/uploads/")) {
      return (
        <Image
          src={link.icon}
          alt={link.platform}
          width={35}
          height={35}
          style={{ objectFit: "contain" }}
        />
      )
    }
    // Fallback to default icon
    return <FacebookIcon />
  }

  return (
    <Styled.LinksWrapper>
      <Styled.Email href={`mailto:${displayEmail}`}>
        {displayEmail}
      </Styled.Email>
      <Styled.IconsList>
        {displaySocialLinks.map((link) => (
          <IconButton
            key={link.id}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            size="large"
          >
            {renderSocialIcon(link)}
          </IconButton>
        ))}
      </Styled.IconsList>
    </Styled.LinksWrapper>
  )
}

export default LinksWrap
